import { RootState, loadingStore } from '../../rootReducer';

export const selectLoading = (state: RootState) => state[loadingStore];
